import * as React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import { IAppointmentScheduleResponse } from "@curefit/care-common";
import { AppConstants } from "../../utils/AppConstants"
import ConsultationUtils from "../../utils/ConsultationUtils";
import { RouteUtils } from "../../routes";
import { ORION_IMG_URL } from "../../utils/AppConstants";
import ClearSlotContainer from "../../containers/ClearSlotContainer";
import MarkDelayContainer from "../../containers/MarkDelayContainer";
import AppUtils from "../../utils/AppUtils";

export interface ConsultationDetailsHeaderProps {
    consultation: IAppointmentScheduleResponse
    redirectToTreatmentPlan: () => void;
    isTreatmentPlanEnabled: boolean;
}

class ConsultationDetailsHeader extends React.Component<ConsultationDetailsHeaderProps> {

    render() {
        let followUpId = !_.isNull(this.props.consultation.followUpConsultationId) && this.props.consultation.followUpConsultationId !== -1 ?
            this.props.consultation.followUpConsultationId : null;
        let patientId = this.props.consultation.patient.id;
        let formattedTime = moment(this.props.consultation.startTime).format("MMM D, dddd");
        let headerText = "Consultation " + formattedTime;
        let consultationTimings = moment(this.props.consultation.startTime).format("h:mm a") + " - " + moment(this.props.consultation.endTime).format("h:mm a");
        const packInfo = this.props.consultation.packInfo && ConsultationUtils.getPackDetails(this.props.consultation);
        return (
            <div className={"consultation-header-common"}>
                <div>
                    <div className={"consultation-detail-header"}>
                        {headerText}
                        {
                            !_.isEmpty(ConsultationUtils.getStatusButtonText(this.props.consultation)) &&
                            <div className={"consultation-status-btn"}>
                                <span className={ConsultationUtils.getStatusButtonCssClasses(this.props.consultation)}>{ConsultationUtils.getStatusButtonText(this.props.consultation)}</span>
                            </div>
                        }
                    </div>
                    <div className="sub-header">
                        <div className="timing" key="1">
                            <img src={ORION_IMG_URL + "icons/consultation-time.svg"} className="consultation-time-icon" />
                            {consultationTimings}
                            {(this.props.consultation as any).delayedInMinutes && <span className={"delayed-time"}>{`Delayed by ${(this.props.consultation as any).delayedInMinutes} minutes`}</span>}
                        </div>
                        <div className="room" key="3">
                            <img src={ORION_IMG_URL + "icons/consultation-icon.svg"} />
                            {AppConstants.ConsultationModes[this.props.consultation.consultationProduct.consultationMode].display}
                        </div>
                        {
                            !_.isNull(followUpId) &&
                            <div className="follow-up" key="4">
                                <img src={ORION_IMG_URL + "icons/follow-up-icon.png"} />
                                <a target="_blank" href={RouteUtils.getPatientConsultationDetailsUrl(patientId, followUpId)}>
                                    Follow Up
                                {/*<span className={"glyphicon glyphicon-new-window"}></span>*/}
                                </a>
                            </div>
                        }
                        {
                            this.props.consultation.room &&
                            <div className="mode" key="2">
                                <img src={ORION_IMG_URL + "icons/consultation-room.svg"} />
                                {`Room no. ${this.props.consultation.room.roomNumber}`}
                            </div>
                        }
                    </div>
                    {
                        packInfo &&
                        <React.Fragment>
                            <div className="appointment-pack-info">
                                <div>Sessions Booked</div>
                                <div><span className="brandon-bold">{packInfo.totalTicketsConsumed}</span> of {packInfo.totalTickets}</div>
                            </div>
                            <div className="appointment-pack-info">
                                <div>Pack Expiry</div>
                                <div><span className="brandon-bold">{AppUtils.getRelativeDay(packInfo.startEndEpoch.endEpoch, "D MMM Y")}</span></div>
                            </div>
                        </React.Fragment>
                    }
                </div>
                <div className="consultation-header-action">
                    {!_.isEmpty(this.props.consultation) && <div className={"cta-cont"}>
                        <ClearSlotContainer startTimeEpoch={this.props.consultation.startTime} endTimeEpoch={this.props.consultation.endTime} centerId={this.props.consultation.center.id} resourceId={this.props.consultation.doctor.id} fetchAppointments={null} patientName={this.props.consultation.patient.name} appointmentStatus={this.props.consultation.status}/>
                        <MarkDelayContainer startTimeEpoch={this.props.consultation.startTime} bookingId={this.props.consultation.bookingId} appointmentId={this.props.consultation.id} patientName={this.props.consultation.patient.name} fetchAppointments={null} appointmentStatus={this.props.consultation.status}/>
                    </div>}
                    {this.props.isTreatmentPlanEnabled && <div style={{textAlign: "right"}}>
                        <div className="action-with-icon" onClick={() => { this.props.redirectToTreatmentPlan() }}>
                            <img src="/images/icons/treatmentPlanHeaderRed.svg" height={19} width={25} />
                            {"Save as Treatment Plan"}
                        </div>
                        <div className="action-disclaimer">
                            <span>{"*"}</span>
                            {"This does not affect the previous consultation in anyway"}
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}

export default ConsultationDetailsHeader;